import {
  AppShell,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Input,
  Label,
  ThemeToggle,
  toast,
  type AppShellNavItem,
} from '@kmgestao/ui';

import { Brand } from '../../components/Brand.js';

const navItems: AppShellNavItem[] = [
  { id: 'dashboard', label: 'Dashboard', href: '#', active: true },
  { id: 'leads', label: 'Leads & Funil', href: '#' },
  { id: 'clinicas', label: 'Clínicas', href: '#' },
  { id: 'ia', label: 'IA & Consultoria', href: '#' },
  { id: 'billing', label: 'Billing', href: '#' },
];

/**
 * Rota de desenvolvimento: showcase dos primitivos `@kmgestao/ui` dentro do
 * `AppShell`, em light + dark. Será removida quando o app tiver rotas reais.
 */
export function DevShowcasePage() {
  return (
    <AppShell
      brand={<Brand />}
      navItems={navItems}
      topbarRight={
        <>
          <Button variant="outline" size="sm">
            Nova clínica
          </Button>
          <ThemeToggle />
        </>
      }
      sidebarFooter={<p className="text-xs text-muted-foreground">v0.0.0 · dev build</p>}
    >
      <div className="mx-auto max-w-5xl p-4 sm:p-6 lg:p-8 space-y-8">
        <header className="space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight">Showcase de primitivos</h1>
          <p className="text-sm text-muted-foreground">
            Componentes de <code className="font-mono text-xs">@kmgestao/ui</code> renderizados em
            light + dark. Rota temporária — remover quando o app tiver conteúdo real.
          </p>
        </header>

        <section className="space-y-3">
          <h2 className="text-lg font-medium">Button — variantes</h2>
          <div className="flex flex-wrap gap-2">
            <Button>Default</Button>
            <Button variant="secondary">Secondary</Button>
            <Button variant="destructive">Destructive</Button>
            <Button variant="outline">Outline</Button>
            <Button variant="ghost">Ghost</Button>
            <Button variant="link">Link</Button>
          </div>
          <div className="flex flex-wrap items-end gap-2">
            <Button size="sm">Small 36px</Button>
            <Button>Default 40px</Button>
            <Button size="lg">Large 44px (CTA mobile)</Button>
          </div>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-medium">Input + Label</h2>
          <div className="grid gap-4 sm:grid-cols-2 max-w-2xl">
            <div className="space-y-2">
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email"
                type="email"
                inputMode="email"
                autoComplete="email"
                placeholder="seu@email.com"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="senha">Senha</Label>
              <Input
                id="senha"
                type="password"
                autoComplete="current-password"
                placeholder="••••••••"
                hasError
              />
              <p className="text-xs text-destructive">Senha deve ter ao menos 12 caracteres.</p>
            </div>
          </div>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-medium">Card composto</h2>
          <div className="grid gap-4 sm:grid-cols-2">
            <Card>
              <CardHeader>
                <CardTitle>Agendamentos hoje</CardTitle>
                <CardDescription>Clínica Santa Rita</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-3xl font-semibold">12</p>
                <p className="text-sm text-muted-foreground">8 confirmados · 4 pendentes</p>
              </CardContent>
              <CardFooter>
                <Button variant="outline" size="sm">
                  Ver agenda
                </Button>
              </CardFooter>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle>MRR do portfólio</CardTitle>
                <CardDescription>Somatório das 14 clínicas ativas</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-3xl font-semibold">R$ 48.720</p>
                <p className="text-sm text-success">+8,2% vs mês anterior</p>
              </CardContent>
            </Card>
          </div>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-medium">Dialog + Toast</h2>
          <div className="flex flex-wrap gap-2">
            <Dialog>
              <DialogTrigger asChild>
                <Button variant="destructive">Excluir paciente</Button>
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Confirmar exclusão</DialogTitle>
                  <DialogDescription>
                    Soft-delete: o registro fica restaurável por 30 dias conforme política de
                    retenção LGPD.
                  </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                  <DialogClose asChild>
                    <Button variant="secondary">Cancelar</Button>
                  </DialogClose>
                  <Button
                    variant="destructive"
                    onClick={() => toast.success('Paciente marcado para exclusão.')}
                  >
                    Confirmar
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>

            <Button
              variant="outline"
              onClick={() =>
                toast('Convite reenviado', {
                  description: 'O link expira em 24h.',
                })
              }
            >
              Toast neutro
            </Button>
            <Button
              variant="outline"
              onClick={() => toast.success('Alteração salva')}
              className="text-success-foreground"
            >
              Toast success
            </Button>
            <Button variant="outline" onClick={() => toast.error('Falha ao conectar com o Asaas')}>
              Toast error
            </Button>
          </div>
        </section>
      </div>
    </AppShell>
  );
}
